// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__24y16","label":"LabeledBox_label__OtFcD"};